import Vue from "vue";
import axios from "axios";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedOrer = () => {
  return {
    orerNo: null,
    versionNo: null,
    name: null,
    totalDistance: null,
    fromStationId: null,
    toStationId: null,
    lineId: null,
    stationDays: [],
    orerStations: [{ station: {} }],
    startDate: null,
    endDate: null,
  };
};

export default {
  state: () => ({
    orers: [],
    selectedOrer: getDefaultSelectedOrer(),
    originalKkyVersion: {},
    lineStations: [],
    lineInformationForUpcomingLineUpdate: null,
    showReferenceOrerArea: false,
    selectKKYOrerLineRequest: null,
  }),
  mutations: {
    setOrers(state, orers) {
      orers = orers.sort((o1, o2) => {
        let o1Weight = o1.orerNo * 100 + o1.versionNo;
        let o2Weight = o2.orerNo * 100 + o2.versionNo;
        return o1Weight - o2Weight;
      });

      Vue.set(state, "orers", orers);
    },
    setSelectedOrer(state, selectedOrer) {
      Vue.set(state, "selectedOrer", selectedOrer);
    },
    setOriginalKkyVersion(state, originalKkyVersion) {
      Vue.set(state, "originalKkyVersion", originalKkyVersion);
    },
    setLineStations(state, lineStations) {
      Vue.set(state, "lineStations", lineStations);
    },
    setLineInformationForUpcomingLineUpdate(state, lineInformationForUpcomingLineUpdate) {
      Vue.set(state, "lineInformationForUpcomingLineUpdate", lineInformationForUpcomingLineUpdate);
    },
    setShowReferenceOrerArea(state, showReferenceOrerArea) {
      Vue.set(state, "showReferenceOrerArea", showReferenceOrerArea);
    },
    setSelectKKYOrerLineRequest(state, selectKKYOrerLineRequest) {
      Vue.set(state, "selectKKYOrerLineRequest", selectKKYOrerLineRequest);
    },
    setDefaultSelectedOrer(state) {
      Vue.set(state, "selectedOrer", getDefaultSelectedOrer());
    },
    setDefaultOrerModule(state) {
      Vue.set(state, "selectedOrer", getDefaultSelectedOrer());
      Vue.set(state, "orers", []);
      Vue.set(state, "originalKkyVersion", {});
      Vue.set(state, "lineStations", []);
      Vue.set(state, "lineInformationForUpcomingLineUpdate", null);
      Vue.set(state, "showReferenceOrerArea", false);
      Vue.set(state, "selectKKYOrerLineRequest", null);
    },
  },
  actions: {
    //TODO: load, create, update, delete
    loadOrers: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/entity").then((response) => {
        // context.commit("setOrers",response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadOrer: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedOrer", response.data);
        return response.data;
      });
    },
    loadPublishedOrers: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/entity/published").then((response) => {
        return response.data;
      });
    },
    loadOrerStationByOrerId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/orer-stations/orer/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadOrersByLineId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/line/" + request.id).then((response) => {
        return response.data;
      });
    },
    createOrer: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/orers/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    deleteOrer: (context, orer) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/orers/entity/" + orer.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          orer.intents = intents;
          orer.intentId = response.data.id;
          return orer;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftOrer: (context, orer) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/orers/draft/" + orer.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishOrer: (context, orer) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/publish/" + orer.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectOrer: (context, orer) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/reject/" + orer.intentId).then((response) => {
        if (orer.intents[0].type === "DELETE_ORER") {
          orer.intents = null;
          orer.intentId = 0;
        } else if (orer.intents[0].type === "CREATE_ORER") {
          orer.intents[0].status = "DRAFT";
        } else if (orer.intents[0].type === "UPDATE_ORER") {
          orer.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallOrer: (context, orer) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/recall/" + orer.intentId).then((response) => {
        helper.recallOrRejectEntity(orer, "orer");
        return response.data;
      });
    },

    cancelOrer: (context, orer) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/cancel/" + orer.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalOrers: (context, orer) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/sendToApproval/" + orer.intentId).then((response) => {
        if (orer.intents[0].type === "CREATE_ORER") {
          orer.intents[0].status = "WAITING_APPROVAL";
        } else if (orer.intents[0].type === "UPDATE_ORER") {
          orer.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    loadSelectedOrerHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    loadOrerStationWithOrerId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/orer-stations/orer/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    loadKkyNos: (context, orerNo) => {
      return axios.get(context.getters.getMcServiceUrl + "/orers/fetch-kky-data/" + orerNo).then((response) => {
        // context.commit("setOrers",response.data);
        return response.data;
      });
    },

    loadKkyVersion: (context, orer) => {
      return axios.post(context.getters.getMcServiceUrl + "/orers/get-kky-data", orer).then((response) => {
        return response.data;
      });
    },

    selectKKYOrerLine: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/lines/select-kky-orer-line", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    findOrersByScheduleIds: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/orers/find-orers-by-schedule-ids", request).then((response) => {
        return response;
      });
    },
  },
  getters: {
    getOrers: (state) => {
      return state.orers;
    },
    getSelectedOrer: (state) => {
      return state.selectedOrer;
    },
    getOriginalKkyVersion: (state) => {
      return state.originalKkyVersion;
    },
    getPublishedOrers: (state) => {
      return state.orers.filter((entity) => {
        return entity.intentId === 0;
      });
    },
    getLineStations: (state) => {
      return state.lineStations;
    },
    getLineInformationForUpcomingLineUpdate: (state) => {
      return state.lineInformationForUpcomingLineUpdate;
    },
    getShowReferenceOrerArea: (state) => {
      return state.showReferenceOrerArea;
    },
    getSelectKKYOrerLineRequest: (state) => {
      return state.selectKKYOrerLineRequest;
    },
  },
};
